module.exports = __webpack_public_path__ + "static/media/plantillaproductos.4d023551.xlsx";